<mat-toolbar class="header">
  <a *ngIf="!hideLogo" href="https://www.capiche-limited.com/about" target="_blank" matTooltip="About Capiche">
    <img class="logo-image" [src]="env.mainLogo" />
  </a>

  <p class="message"></p>

  <div class="header-controls">
    <!-- Font: always available, regardless of login state -->
    <button mat-icon-button [matMenuTriggerFor]="voiceMenu" matTooltip="Choose voice" *ngIf="effectiveLoggedIn && voiceList.length > 1">
      <mat-icon>record_voice_over</mat-icon>
    </button>
    <mat-menu #voiceMenu="matMenu">
      <button *ngFor="let voice of voiceList" mat-menu-item (click)="onVoiceChange(voice.name)">
        <mat-icon *ngIf="selectedVoiceName === voice.name">check</mat-icon>
        <mat-icon *ngIf="selectedVoiceName !== voice.name" style="visibility: hidden">check</mat-icon>
        <span [style.font-family]="selectedFontFamily">{{ voice.name }}</span>
      </button>
    </mat-menu>

    <button mat-icon-button [matMenuTriggerFor]="fontMenu" matTooltip="Choose font">
      <mat-icon>font_download</mat-icon>
    </button>
    <mat-menu #fontMenu="matMenu">
      <button *ngFor="let opt of fontOptions" mat-menu-item (click)="onFontChange(opt.value)">
        <mat-icon *ngIf="selectedFont === opt.value">check</mat-icon>
        <mat-icon *ngIf="selectedFont !== opt.value" style="visibility: hidden">check</mat-icon>
        <span [style.font-family]="opt.fontFamily">{{ opt.label }}</span>
      </button>
    </mat-menu>

    <!-- Colour: only when logged in (any user type), and only where there's an
         editor for it to repaint (see hideColorPalette's doc comment) -->
    <app-color-palette *ngIf="effectiveLoggedIn && !hideColorPalette" matTooltip="Editor background colour"></app-color-palette>

    <!-- Account: only for B2C — teachers have their own portal, students have no
         account to manage and policy docs are a B2C-only concern here -->
    <button
      mat-icon-button
      *ngIf="effectiveB2C"
      #profileTrigger="matMenuTrigger"
      [matMenuTriggerFor]="profileMenu"
      [class.jiggle]="jiggleAccount"
      matTooltip="My account"
    >
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #profileMenu="matMenu">
      <!-- CSW-1671: one-time community nudge, rendered inside the menu panel (not a
           separate overlay — mat-menu closes on any outside interaction). -->
      <div *ngIf="showCommunityCard" class="community-card" (click)="$event.stopPropagation()">
        <p class="community-card__title">Join the Capiche Community</p>
        <p class="community-card__body">{{ communityBlurb }}</p>
        <div class="community-card__actions">
          <button mat-flat-button color="primary" (click)="onCommunityOpen()">Join now</button>
          <button mat-button (click)="onCommunityDecline()">No thanks</button>
        </div>
      </div>
      <a
        *ngIf="showCommunityLink && !showCommunityCard"
        mat-menu-item
        (click)="onCommunityOpen()"
      >
        <mat-icon>groups</mat-icon>
        Community
      </a>
      <button mat-menu-item (click)="onManageAccount()">Manage account</button>
      <a *ngIf="isTeacher && teacherPortalUrl" mat-menu-item [href]="teacherPortalUrl" target="_blank" rel="noopener">
        <mat-icon>school</mat-icon>
        Teacher Portal
      </a>
      <button mat-menu-item (click)="onTermsOfUse()">Terms of use</button>
      <button mat-menu-item (click)="onPrivacyPolicy()">Privacy policy</button>
      <button mat-menu-item (click)="onLogout()">Log out</button>
    </mat-menu>

    <!-- Standalone logout: for logged-in users who don't have the account menu
         above (students; teachers outside the embedded editor) — they still need
         a way to log out without exposing "Manage account" or policy docs.
         Suppressed entirely when hideLogout is set (teacher-portal editor iframe —
         the dashboard already owns sign-out there; a second logout button inside
         the iframe would only sign the user out of the underlying web-app session,
         not the dashboard, which is confusing and not this component's job). -->
    <button mat-icon-button *ngIf="effectiveLoggedIn && !effectiveB2C && !hideLogout" (click)="onLogout()" matTooltip="Log out">
      <mat-icon>logout</mat-icon>
    </button>
  </div>
</mat-toolbar>
